import { Checkbox, Input } from 'antd';

const CustomSpecificCheckbox = ({
  Form,
  rules,
  data,
  parentKey,
  renderCheckbox,
  otherOption,
  handleOtherOption,
}) => {
  return (
    <>
      <Form.Item
        name={[parentKey, data.name]}
        label={data.title}
        rules={rules?.[data?.name]}
      >
        <Checkbox.Group onChange={(e) => handleOtherOption(e, data)} >
          {renderCheckbox(data.options)}
          <Checkbox value={'other'}>
          Please specify
            {otherOption?.[data?.name] && (
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: 'Please specify your choice'
                  }
                ]}
                className='form_group'
                name={data.name}
              >
                <Input
                  style={{
                    width: 300,
                    height: 30,
                  }}
                  name={data.name}
                  placeholder='Please specify'
                  className='form_control'
                />
              </Form.Item>
            )}
          </Checkbox>
        </Checkbox.Group>
      </Form.Item>
    </>
  );
};

export default CustomSpecificCheckbox;
